import React from "react";
import coupleImg1 from "../../images/couple/image-1.jpg";
import coupleImg2 from "../../images/couple/image-2.jpg";
import coupleImg3 from "../../images/couple/image-3.jpg";

const CoupleSection: React.FC = () => {
  return (
    <section className="wpo-couple-section">
      <div className="container">
        <div className="row">
          {/* Bride */}
          <div className="col col-lg-3 col-md-12 col-12">
            <div
              className="couple-items wow fadeInLeftSlow"
              data-wow-duration="1400ms"
            >
              <div className="couple-image">
                <img src={coupleImg1} alt="Bride Amanda Jenny" />
              </div>
              <div className="couple-text">
                <h2>Amanda Jenny</h2>
                <p>
                  Today, I marry my best friend. With joy in my heart and love
                  in my eyes, I’m ready for forever.
                </p>
              </div>
            </div>
          </div>

          {/* Center Photo */}
          <div className="col col-lg-6 col-md-12 col-12">
            <div
              className="couple-middle-pic wow zoomIn"
              data-wow-duration="1700ms"
            >
              <div className="couple-image">
                <img src={coupleImg2} alt="Wedding Couple" />
              </div>
            </div>
          </div>

          {/* Groom */}
          <div className="col col-lg-3 col-md-12 col-12">
            <div
              className="couple-items wow fadeInRightSlow"
              data-wow-duration="1400ms"
            >
              <div className="couple-image">
                <img src={coupleImg3} alt="Groom Max Wilson" />
              </div>
              <div className="couple-text">
                <h2>Max Wilson</h2>
                <p>
                  A heart full of love and a soul full of hope, I can't wait to
                  begin this journey with you by my side.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoupleSection;
